<!--  section  -->
<section class="gray-bg small-padding no-top-padding-sec" id="sec1">
    <div class="container">
        <div class="breadcrumbs inline-breadcrumbs fl-wrap block-breadcrumbs">
            <a href="/home">Home</a><a href="/products">Product</a><span>Cart</span>
        </div>
        <div class="clearfix"></div>
        <!-- CHECKOUT TABLE -->
        <div class=" fl-wrap">
            <h4 class="cart-ttitle ">Your Cart</h4>
            <div *ngFor="let item of items"> 
             {{item.quantity}} 
            <div *ngFor="let item of item.product"> 
                <ul> 
                        {{item.sellProductTitle}} 
                </ul> 
                
            </div>
            </div>

            <table class="table table-border checkout-table">
                <tbody>
                    <tr>
                        <th class="hidden-xs">Item</th>
                        <th>Description</th>
                        <th class="hidden-xs">Price</th>
                        <th>Quantity</th>
                        <th>Total</th>
                        <th></th>
                    </tr>


                    <tr *ngFor="let item of items">
                        <td class="hidden-xs">
                            <a href="#" title="View product"><img src="../../assets/images/shop/1.jpg" alt="{{item.product.sellProductTitle}}" loading="lazy" decoding="async" class="respimg"></a>
                        </td>
                        <td>
                            <h5 class="product-name">{{item.product.sellProductTitle}}</h5>
                        </td>
                        <td class="hidden-xs">
                            <h5 class="order-money">
                            </h5>
                        </td>
                        <td>
                            <input type="number" name="qty37" step="1" value="{{item.quantity}}" max="50" min="1" (click)="addQty(item)" class="order-count color-bg">
                        </td>
                        <td>
                            <h5 class="order-money">
                                Rs 56.00
                            </h5>
                        </td>
                        <td class="pr-remove">
                            <a href="#" title="Remove" (click)="deleteItem(item)"><i class="fal fa-times"></i></a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <!-- /CHECKOUT TABLE -->
        <!-- COUPON -->
        <div class="coupon-holder fl-wrap">
            <input type="text" name="" placeholder="Coupon code">
            <button type="submit" class="btn-a color2-bg">Apply</button>
            <button type="submit" class="pull-right color-bg btn-uc">Update Cart</button>
        </div>
        <!-- /COUPON -->
        <!-- CART TOTALS  -->
        <div class="row">
            <div class="col-sm-5 col-sm-offset-7">
                <div class="cart-totals">
                    <h4 class="cart-ttitle ">Cart Totals</h4>
                    <table class="table table-border checkout-table">
                        <tbody>
                            <tr>
                                <th>Cart Subtotal:</th>
                                <td>Rs40.00</td>
                            </tr>
                            <tr>
                                <th>Shipping Total:</th>
                                <td>Rs2.00</td>
                            </tr>
                            <tr>
                                <th>Total:</th>
                                <td>Rs42.00</td>
                            </tr>
                        </tbody>
                    </table>
                    <button type="submit" class="btn color-bg btn-d" onclick="window.location.href='booking.html'">Proceed to Checkout</button>
                </div>
            </div>
        </div>
        <!-- /CART TOTALS  -->
    </div>
</section>
<div class="limit-box fl-wrap"></div>